// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--2gV_n","icon":"Header-module--icon--1N616","loop":"Header-module--loop--2gDhO"};